import { useCallback, useRef, useState } from 'react';

import { Button, Snackbar } from '@/ui';

import type { FC } from 'react';

export interface ToastState {
  id: number;
  message: string;
  onUndo?: () => void;
}

// Prototype toast(): 5.2 s with Undo, 2.6 s without.
export const UNDO_TOAST_MS = 5200;
export const PLAIN_TOAST_MS = 2600;

export const useToast = () => {
  const [toast, setToast] = useState<ToastState | null>(null);
  const sequence = useRef(0);
  const show = useCallback((message: string, onUndo?: () => void) => {
    sequence.current += 1;
    setToast({ id: sequence.current, message, onUndo });
  }, []);
  const close = useCallback(() => setToast(null), []);
  return { close, show, toast };
};

export const Toast: FC<{ onClose: () => void; toast: ToastState | null }> = ({
  onClose,
  toast,
}) => {
  const onUndo = toast?.onUndo;
  return (
    <Snackbar
      key={toast?.id}
      action={
        onUndo ? (
          <Button
            color="inherit"
            size="small"
            variant="text"
            onClick={() => {
              onUndo();
              onClose();
            }}
          >
            Undo
          </Button>
        ) : undefined
      }
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      autoHideDuration={onUndo ? UNDO_TOAST_MS : PLAIN_TOAST_MS}
      message={toast?.message}
      open={toast !== null}
      onClose={(_event, reason) => {
        if (reason !== 'clickaway') onClose();
      }}
    />
  );
};
